import { TestConfig } from 'yup';
import { TranslateFunction } from 'b2b-server/core/utils/language';


/*
 * This function is intended to be used as the input for Yup Scheme.test() input.
 * Example: https://github.com/jquense/yup#schematestoptions-object-schema
 */
export const validateCharactersLimit = (maxCharacters: number, t: TranslateFunction): TestConfig<string> => ({
  name: 'validateCharactersLimit',
  test: (value: string | undefined) => {
    if (value) {
      return value.length <= maxCharacters;
    }
    return true;
  },
  message: (params: { value: string }) => (
    t('Characters limit exceeded ({n} over limit)', { n: params.value.length - maxCharacters })
  ),
});
